// Shared user-facing registration messages - see featureplans/events-rsvp-blocking-questions.md.
// Default shown when a blocking answer is chosen and the organiser left the custom message blank.
// MUST match ttbackendflyio/utils/constants/registrationMessages.js exactly (one canonical wording).
export const DEFAULT_BLOCK_MESSAGE = "Based on your answer, you're not able to register for this event.";
